import { render, staticRenderFns } from "./activity-code.vue?vue&type=template&id=2dcbb032&lang=pug&"
import script from "./activity-code.vue?vue&type=script&lang=js&"
export * from "./activity-code.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports